import { useState, useEffect } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: '何も決まっていない状態でも相談できますか？',
    answer: 'はい、大丈夫です。\n多くの方が「何から考えればいいのか分からない」状態でご相談されています。\n状況を一つずつ確認しながら、考える順番を一緒に整えていきます。'
  },
  {
    question: '相談したら、必ずどこかの会社を紹介されますか？',
    answer: '必ず紹介するわけではありません。\n状況によっては、今は動かない方が良いとお伝えすることもあります。\n無理に進めることはありませんのでご安心ください。'
  },
  {
    question: '相談の途中でやめることはできますか？',
    answer: 'はい、いつでも可能です。\nご自身で考えが整理できた時点で終了していただいて構いません。\nその後の連絡や勧誘も行いません。'
  },
  {
    question: '相談料はいくらくらいかかりますか？',
    answer: '相談内容にもよりますが、目安としては数万円程度の相談料をいただいています。\n無料相談ではなく、有料にすることで、特定の会社に偏らない判断サポートを行っています。\n詳しい金額はLINEで状況を伺ったうえでご案内しています。'
  },
  {
    question: 'LINEだけで相談は完結しますか？',
    answer: '基本的なご相談はLINEで完結します。\n内容によっては、通話やオンライン相談をご提案する場合もありますが、\n必須ではありません。'
  },
  {
    question: '住宅会社や不動産会社から営業されませんか？',
    answer: 'ご本人の同意なく、情報を共有することはありません。\n勝手に連絡が入ることはありませんのでご安心ください。'
  },
  {
    question: '相談料以外に、追加で費用はかかりますか？',
    answer: '相談料以外の費用は発生しません。\n追加料金やオプション費用は一切ありません。'
  },
  {
    question: 'どのタイミングで相談するのが一番良いですか？',
    answer: '「迷い始めた時」が一番おすすめです。\n何かを決め切る前にご相談いただくことで、\n後悔の少ない判断につながります。'
  }
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqData.map(faq => ({
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faq.answer
        }
      }))
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(faqSchema);
    script.id = 'faq-schema-org';
    
    const existingScript = document.getElementById('faq-schema-org');
    if (existingScript) {
      existingScript.remove();
    }
    
    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.getElementById('faq-schema-org');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, []);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-[1100px] mx-auto px-6">
        <h2 className="text-3xl font-bold text-[#7A5A44] text-center mb-12">
          よくあるご質問
        </h2>
        
        <div className="space-y-4">
          {faqData.map((faq, index) => (
            <div key={index} className="rounded-lg overflow-hidden">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full bg-[#E6F0EB] px-6 py-4 text-left flex items-center justify-between hover:opacity-90 transition-opacity cursor-pointer"
              >
                <span className="text-[#5A4033] font-medium pr-4">{faq.question}</span>
                <i className={`ri-arrow-down-s-line text-2xl text-[#5A4033] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}></i>
              </button>
              
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-[500px]' : 'max-h-0'
                }`}
              >
                <div className="bg-white px-6 py-5 border-l-4 border-[#8FAE9A]">
                  <p className="text-[#5A4033] leading-[1.8] whitespace-pre-line">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
